import { PaymentTypes } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class PaymentCreateDto{
    @ApiProperty()
    asnId:number
    @ApiProperty()
    paymentDate:any
    @ApiProperty()
    paymentType:PaymentTypes
    @ApiProperty()
    receivedAmount:number
}